// import { createI18n } from 'vue-i18n';
import { createI18n } from 'vue-i18n/index';

const en = require('@lang/en.json');
const zh = require('@lang/zh.json');

const messages = { en, zh };

const i18n = createI18n({
  messages,
  locale: 'en',
  missingWarn: false,
  fallbackWarn: false,
  fallbackLocale: 'en',
  warnHtmlMessage: false,
});

export default i18n;
